class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.dispatchVariantChange();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent(
        'variant-change',
        {
          bubbles: true,
          variant: this.currentVariant,
          detail: {
            variant: this.currentVariant
          }
        }
      )
    );
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `#price-${this.dataset.section}`;
      const idName = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destinations = document.querySelectorAll(id);
      destinations.forEach((destination) => {
        const source = html.getElementById(idName);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        if (this.currentVariant) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }
      });
      // Update the inventory quantity hidden input
      const inventoryQtyDestination = document.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
      const inventoryQtySource = html.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
      inventoryQtyDestination.value = inventoryQtySource.value;

      //Update shipping usp for selected variant
      const defaultUsp = document.querySelector('[data-first-usp]');
      const preorderUsp = document.querySelector('[data-preorder-usp]');

      //show preorder usp if exist when current selected variant has no inventory
      if (preorderUsp) {
        defaultUsp.classList.add('hidden');
        preorderUsp.classList.remove('hidden');
      }
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const toggleStickyBtn = document.querySelector('[data-form-toggle]');
    if (!addButton) return;
    if (!toggleStickyBtn.classList.contains('visibility-hidden')) {
      toggleStickyBtn.classList.add('visibility-hidden');
    }

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (addButton.classList.contains('comingsoon')) {
        addButton.textContent = window.variantStrings.comingSoon;
      } else {
        addButton.textContent = text;
      }
    } else {
      // Update the submit button
      addButton.removeAttribute('disabled');
      if (addButton.classList.contains('preorder')) {
        addButton.textContent = window.variantStrings.preOrder;
      } else if (addButton.classList.contains('comingsoon')) {
        addButton.textContent = window.variantStrings.comingSoon;
      } else {
        addButton.textContent = window.variantStrings.addToCart;
      }
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.handleStatusSellingFast();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  /**
   * handleStatusSellingFast
   * @description Show the still 1 on stock message based on click or mouse event.
   */
  handleStatusSellingFast() {
    this.contentElm = this.querySelector('[data-status-selling-fast]');
    if (this.contentElm) {
      const content = this.contentElm.dataset.translation;
      this.countElm = this.querySelector('[data-inventory]');
      this.triggers = this.querySelectorAll('[data-trigger-status-selling-fast]');
      this.maxAmount = parseInt(this.contentElm.getAttribute('data-max-inventory'));
      const htmlElm = document.querySelector('html');

      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          const inventory = trigger.getAttribute('data-variant-inventory');
          if (inventory > 0 && inventory <= this.maxAmount) {
            this.countElm.innerHTML = inventory;
            this.countElm.setAttribute('data-variant-inventory',inventory);
            this.contentElm.classList.add('status-selling-fast--active');

          } else {
            this.countElm.innerHTML = inventory;
            this.countElm.setAttribute('data-variant-inventory',inventory);
            this.contentElm.classList.remove('status-selling-fast--active');
          }
        })
        if (htmlElm.classList.contains('no-touch')) {
          trigger.addEventListener('mouseenter', () => {
            const inventory = parseInt(trigger.getAttribute('data-variant-inventory'));
            if (inventory > 0 && inventory <= this.maxAmount) {
              this.contentElm.classList.add('status-selling-fast--active-hover');
              this.contentElm.innerHTML = content.replace('[[ count ]]', inventory);
            }
          })
          trigger.addEventListener('mouseleave', () => {
            this.contentElm.classList.remove('status-selling-fast--active-hover');
          })
        }

      });
    }
  }

}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}
